{ featureFlagClient } = require '@trello/feature-flag-client'
t = require('app/scripts/views/internal/teacup-with-helpers')('mini_profile')

module.exports = t.renderable ({ avatarUrl, viewTitle, fullName, username, initials, bio, email, showEmail, isMe }) ->
  t.div '.mini-profile', ->

    t.div '.mini-profile-member.member-large', ->
      if avatarUrl
        t.a '.av-btn.js-view-large', { href: '#' }
      title = viewTitle
      if avatarUrl
        t.img '.member-avatar', { height: '50', width: '50', src: [avatarUrl, '50.png'].join('/'), alt: title, title }
      else if initials
        t.span '.member-initials', { title }, ->
          t.text initials
      else
        t.div '.member-icon-container', ->
          t.icon 'member'

    t.div '.mini-profile-info', ->
      t.h3 '.mini-profile-info-title', ->
        t.a '.mini-profile-info-title-link.js-profile', { href: "/#{username}" }, ->
          t.text fullName
      t.p '.quiet.u-bottom', ->
        t.format 'at-username', { username }

      if bio
        t.p '.mini-profile-info-bio.quiet', ->
          t.text bio
      if showEmail
        t.p '.u-bottom.quiet', ->
          t.text email
      if isMe
        t.p '.u-bottom', ->
          className = '.quiet'
          href = "/#{username}/profile"
          t.a className, { href }, ->
            t.format 'edit-profile-info'

